import { Sections } from '../types/Sections';

export const goToSection = (sectionId: Sections) => {
  const element = document.getElementById(sectionId);

  if (element instanceof HTMLElement) {
    element.classList.add(`main__${sectionId}--shown`);

    window.scrollBy(0, 200);
    window.location.hash = sectionId;
  }
};
